module.exports = __webpack_public_path__ + "static/img/label.672bd4cc.png";